import  { useEffect, useState } from "react"; 
import { FromDateTime, ToDateTime } from "../../components/datetime";
import { UserInfo } from "../../models/userinfo";  
import {authToken, AccountId, UserInfoUserId } from "@/src/app/components/authInfo";
 

export async function CreateNewUser(){
  const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
 

  const Saveuserdetails = async (userinfo:UserInfo): Promise<UserInfo> => {
    const data = { 
      userinfo: userinfo };
    const response = await fetch(`${API_BASE_URL}/Account/Account/SaveUserInfo`, {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization": `Bearer ${authToken()}` },
      body: JSON.stringify(data),
    });

     return await response.json(); 
};
 
return{ 
    Saveuserdetails, 
}
}
